/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppAbsencesRouteImport } from './routes/_app/absences'
import { Route as AppAdminRouteImport } from './routes/_app/admin'
import { Route as AppMyResourcesRouteImport } from './routes/_app/my-resources'
import { Route as AppMyTasksRouteImport } from './routes/_app/my-tasks'
import { Route as AppNotificationsRouteImport } from './routes/_app/notifications'
import { Route as AppProjectTemplatesRouteImport } from './routes/_app/project-templates'
import { Route as AppProjectsRouteImport } from './routes/_app/projects'
import { Route as AppResourcesRouteImport } from './routes/_app/resources'
import { Route as AppSkillsRouteImport } from './routes/_app/skills'
import { Route as PublicForgotPasswordRouteImport } from './routes/_public/forgot-password'
import { Route as PublicLoginRouteImport } from './routes/_public/login'
import { Route as PublicResetPasswordRouteImport } from './routes/_public/reset-password'
import { Route as PublicSetup2faRouteImport } from './routes/_public/setup-2fa'
import { Route as AppAdminIndexRouteImport } from './routes/_app/admin/index'
import { Route as AppAdminAuditRouteImport } from './routes/_app/admin/audit'
import { Route as AppAdminJobRolesRouteImport } from './routes/_app/admin/job-roles'
import { Route as AppAdminOrganizationsRouteImport } from './routes/_app/admin/organizations'
import { Route as AppAdminSkillsRouteImport } from './routes/_app/admin/skills'
import { Route as AppAdminSystemRouteImport } from './routes/_app/admin/system'
import { Route as AppPProjectKeyRouteImport } from './routes/_app/p.$projectKey'
import { Route as AppResourcesIndexRouteImport } from './routes/_app/resources.index'
import { Route as AppResourcesRolesRouteImport } from './routes/_app/resources.roles'
import { Route as PublicInviteTokenRouteImport } from './routes/_public/invite.$token'
import { Route as AppAdminResourcesIndexRouteImport } from './routes/_app/admin/resources.index'
import { Route as AppAdminResourcesUserIdRouteImport } from './routes/_app/admin/resources.$userId'
import { Route as AppAdminRolesIndexRouteImport } from './routes/_app/admin/roles.index'
import { Route as AppAdminRolesRoleIdRouteImport } from './routes/_app/admin/roles.$roleId'
import { Route as AppAdminRolesNewRouteImport } from './routes/_app/admin/roles.new'
import { Route as AppAdminUsersIndexRouteImport } from './routes/_app/admin/users.index'
import { Route as AppAdminUsersUserIdRouteImport } from './routes/_app/admin/users.$userId'
import { Route as AppPProjectKeyIndexRouteImport } from './routes/_app/p.$projectKey/index'
import { Route as AppPProjectKeyTaskKeyRouteImport } from './routes/_app/p.$projectKey/$taskKey'
import { Route as AppPProjectKeyBoardRouteImport } from './routes/_app/p.$projectKey/board'
import { Route as AppPProjectKeyCalendarRouteImport } from './routes/_app/p.$projectKey/calendar'
import { Route as AppPProjectKeyGanttRouteImport } from './routes/_app/p.$projectKey/gantt'
import { Route as AppPProjectKeyResourcesRouteImport } from './routes/_app/p.$projectKey/resources'
import { Route as AppPProjectKeySettingsRouteImport } from './routes/_app/p.$projectKey/settings'
import { Route as AppPProjectKeyTasksRouteImport } from './routes/_app/p.$projectKey/tasks'
import { Route as AppResourcesPeopleUserIdRouteImport } from './routes/_app/resources.people.$userId'
import { Route as AppPProjectKeyReportsIndexRouteImport } from './routes/_app/p.$projectKey/reports.index'
import { Route as AppPProjectKeyReportsReportIdRouteImport } from './routes/_app/p.$projectKey/reports.$reportId'
import { Route as AppPProjectKeySettingsIndexRouteImport } from './routes/_app/p.$projectKey/settings/index'
import { Route as AppPProjectKeySettingsGeneralRouteImport } from './routes/_app/p.$projectKey/settings/general'
import { Route as AppPProjectKeySettingsLabelsRouteImport } from './routes/_app/p.$projectKey/settings/labels'
import { Route as AppPProjectKeySettingsMembersRouteImport } from './routes/_app/p.$projectKey/settings/members'
import { Route as AppPProjectKeySettingsTrashRouteImport } from './routes/_app/p.$projectKey/settings/trash'
import { Route as AppPProjectKeySettingsWorkflowRouteImport } from './routes/_app/p.$projectKey/settings/workflow'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppAbsencesRoute = AppAbsencesRouteImport.update({
  id: '/absences',
  path: '/absences',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminRoute = AppAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AppRoute,
} as any)
const AppMyResourcesRoute = AppMyResourcesRouteImport.update({
  id: '/my-resources',
  path: '/my-resources',
  getParentRoute: () => AppRoute,
} as any)
const AppMyTasksRoute = AppMyTasksRouteImport.update({
  id: '/my-tasks',
  path: '/my-tasks',
  getParentRoute: () => AppRoute,
} as any)
const AppNotificationsRoute = AppNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectTemplatesRoute = AppProjectTemplatesRouteImport.update({
  id: '/project-templates',
  path: '/project-templates',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectsRoute = AppProjectsRouteImport.update({
  id: '/projects',
  path: '/projects',
  getParentRoute: () => AppRoute,
} as any)
const AppResourcesRoute = AppResourcesRouteImport.update({
  id: '/resources',
  path: '/resources',
  getParentRoute: () => AppRoute,
} as any)
const AppSkillsRoute = AppSkillsRouteImport.update({
  id: '/skills',
  path: '/skills',
  getParentRoute: () => AppRoute,
} as any)
const PublicForgotPasswordRoute = PublicForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => PublicRoute,
} as any)
const PublicLoginRoute = PublicLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => PublicRoute,
} as any)
const PublicResetPasswordRoute = PublicResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => PublicRoute,
} as any)
const PublicSetup2faRoute = PublicSetup2faRouteImport.update({
  id: '/setup-2fa',
  path: '/setup-2fa',
  getParentRoute: () => PublicRoute,
} as any)
const AppAdminIndexRoute = AppAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminAuditRoute = AppAdminAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminJobRolesRoute = AppAdminJobRolesRouteImport.update({
  id: '/job-roles',
  path: '/job-roles',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminOrganizationsRoute = AppAdminOrganizationsRouteImport.update({
  id: '/organizations',
  path: '/organizations',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminSkillsRoute = AppAdminSkillsRouteImport.update({
  id: '/skills',
  path: '/skills',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminSystemRoute = AppAdminSystemRouteImport.update({
  id: '/system',
  path: '/system',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppPProjectKeyRoute = AppPProjectKeyRouteImport.update({
  id: '/p/$projectKey',
  path: '/p/$projectKey',
  getParentRoute: () => AppRoute,
} as any)
const AppResourcesIndexRoute = AppResourcesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppResourcesRoute,
} as any)
const AppResourcesRolesRoute = AppResourcesRolesRouteImport.update({
  id: '/roles',
  path: '/roles',
  getParentRoute: () => AppResourcesRoute,
} as any)
const PublicInviteTokenRoute = PublicInviteTokenRouteImport.update({
  id: '/invite/$token',
  path: '/invite/$token',
  getParentRoute: () => PublicRoute,
} as any)
const AppAdminResourcesIndexRoute = AppAdminResourcesIndexRouteImport.update({
  id: '/resources/',
  path: '/resources/',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminResourcesUserIdRoute = AppAdminResourcesUserIdRouteImport.update({
  id: '/resources/$userId',
  path: '/resources/$userId',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminRolesIndexRoute = AppAdminRolesIndexRouteImport.update({
  id: '/roles/',
  path: '/roles/',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminRolesRoleIdRoute = AppAdminRolesRoleIdRouteImport.update({
  id: '/roles/$roleId',
  path: '/roles/$roleId',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminRolesNewRoute = AppAdminRolesNewRouteImport.update({
  id: '/roles/new',
  path: '/roles/new',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminUsersIndexRoute = AppAdminUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminUsersUserIdRoute = AppAdminUsersUserIdRouteImport.update({
  id: '/users/$userId',
  path: '/users/$userId',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppPProjectKeyIndexRoute = AppPProjectKeyIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppPProjectKeyRoute,
} as any)
const AppPProjectKeyTaskKeyRoute = AppPProjectKeyTaskKeyRouteImport.update({
  id: '/$taskKey',
  path: '/$taskKey',
  getParentRoute: () => AppPProjectKeyRoute,
} as any)
const AppPProjectKeyBoardRoute = AppPProjectKeyBoardRouteImport.update({
  id: '/board',
  path: '/board',
  getParentRoute: () => AppPProjectKeyRoute,
} as any)
const AppPProjectKeyCalendarRoute = AppPProjectKeyCalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => AppPProjectKeyRoute,
} as any)
const AppPProjectKeyGanttRoute = AppPProjectKeyGanttRouteImport.update({
  id: '/gantt',
  path: '/gantt',
  getParentRoute: () => AppPProjectKeyRoute,
} as any)
const AppPProjectKeyResourcesRoute = AppPProjectKeyResourcesRouteImport.update({
  id: '/resources',
  path: '/resources',
  getParentRoute: () => AppPProjectKeyRoute,
} as any)
const AppPProjectKeySettingsRoute = AppPProjectKeySettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppPProjectKeyRoute,
} as any)
const AppPProjectKeyTasksRoute = AppPProjectKeyTasksRouteImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => AppPProjectKeyRoute,
} as any)
const AppResourcesPeopleUserIdRoute =
  AppResourcesPeopleUserIdRouteImport.update({
    id: '/people/$userId',
    path: '/people/$userId',
    getParentRoute: () => AppResourcesRoute,
  } as any)
const AppPProjectKeyReportsIndexRoute =
  AppPProjectKeyReportsIndexRouteImport.update({
    id: '/reports/',
    path: '/reports/',
    getParentRoute: () => AppPProjectKeyRoute,
  } as any)
const AppPProjectKeyReportsReportIdRoute =
  AppPProjectKeyReportsReportIdRouteImport.update({
    id: '/reports/$reportId',
    path: '/reports/$reportId',
    getParentRoute: () => AppPProjectKeyRoute,
  } as any)
const AppPProjectKeySettingsIndexRoute =
  AppPProjectKeySettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppPProjectKeySettingsRoute,
  } as any)
const AppPProjectKeySettingsGeneralRoute =
  AppPProjectKeySettingsGeneralRouteImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: () => AppPProjectKeySettingsRoute,
  } as any)
const AppPProjectKeySettingsLabelsRoute =
  AppPProjectKeySettingsLabelsRouteImport.update({
    id: '/labels',
    path: '/labels',
    getParentRoute: () => AppPProjectKeySettingsRoute,
  } as any)
const AppPProjectKeySettingsMembersRoute =
  AppPProjectKeySettingsMembersRouteImport.update({
    id: '/members',
    path: '/members',
    getParentRoute: () => AppPProjectKeySettingsRoute,
  } as any)
const AppPProjectKeySettingsTrashRoute =
  AppPProjectKeySettingsTrashRouteImport.update({
    id: '/trash',
    path: '/trash',
    getParentRoute: () => AppPProjectKeySettingsRoute,
  } as any)
const AppPProjectKeySettingsWorkflowRoute =
  AppPProjectKeySettingsWorkflowRouteImport.update({
    id: '/workflow',
    path: '/workflow',
    getParentRoute: () => AppPProjectKeySettingsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/absences': typeof AppAbsencesRoute
  '/admin': typeof AppAdminRouteWithChildren
  '/my-resources': typeof AppMyResourcesRoute
  '/my-tasks': typeof AppMyTasksRoute
  '/notifications': typeof AppNotificationsRoute
  '/project-templates': typeof AppProjectTemplatesRoute
  '/projects': typeof AppProjectsRoute
  '/resources': typeof AppResourcesRouteWithChildren
  '/skills': typeof AppSkillsRoute
  '/forgot-password': typeof PublicForgotPasswordRoute
  '/login': typeof PublicLoginRoute
  '/reset-password': typeof PublicResetPasswordRoute
  '/setup-2fa': typeof PublicSetup2faRoute
  '/admin/audit': typeof AppAdminAuditRoute
  '/admin/job-roles': typeof AppAdminJobRolesRoute
  '/admin/organizations': typeof AppAdminOrganizationsRoute
  '/admin/skills': typeof AppAdminSkillsRoute
  '/admin/system': typeof AppAdminSystemRoute
  '/p/$projectKey': typeof AppPProjectKeyRouteWithChildren
  '/resources/roles': typeof AppResourcesRolesRoute
  '/invite/$token': typeof PublicInviteTokenRoute
  '/admin/': typeof AppAdminIndexRoute
  '/resources/': typeof AppResourcesIndexRoute
  '/admin/resources/$userId': typeof AppAdminResourcesUserIdRoute
  '/admin/roles/$roleId': typeof AppAdminRolesRoleIdRoute
  '/admin/roles/new': typeof AppAdminRolesNewRoute
  '/admin/users/$userId': typeof AppAdminUsersUserIdRoute
  '/p/$projectKey/$taskKey': typeof AppPProjectKeyTaskKeyRoute
  '/p/$projectKey/board': typeof AppPProjectKeyBoardRoute
  '/p/$projectKey/calendar': typeof AppPProjectKeyCalendarRoute
  '/p/$projectKey/gantt': typeof AppPProjectKeyGanttRoute
  '/p/$projectKey/resources': typeof AppPProjectKeyResourcesRoute
  '/p/$projectKey/settings': typeof AppPProjectKeySettingsRouteWithChildren
  '/p/$projectKey/tasks': typeof AppPProjectKeyTasksRoute
  '/resources/people/$userId': typeof AppResourcesPeopleUserIdRoute
  '/admin/resources/': typeof AppAdminResourcesIndexRoute
  '/admin/roles/': typeof AppAdminRolesIndexRoute
  '/admin/users/': typeof AppAdminUsersIndexRoute
  '/p/$projectKey/': typeof AppPProjectKeyIndexRoute
  '/p/$projectKey/reports/$reportId': typeof AppPProjectKeyReportsReportIdRoute
  '/p/$projectKey/settings/general': typeof AppPProjectKeySettingsGeneralRoute
  '/p/$projectKey/settings/labels': typeof AppPProjectKeySettingsLabelsRoute
  '/p/$projectKey/settings/members': typeof AppPProjectKeySettingsMembersRoute
  '/p/$projectKey/settings/trash': typeof AppPProjectKeySettingsTrashRoute
  '/p/$projectKey/settings/workflow': typeof AppPProjectKeySettingsWorkflowRoute
  '/p/$projectKey/reports/': typeof AppPProjectKeyReportsIndexRoute
  '/p/$projectKey/settings/': typeof AppPProjectKeySettingsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof AppIndexRoute
  '/absences': typeof AppAbsencesRoute
  '/my-resources': typeof AppMyResourcesRoute
  '/my-tasks': typeof AppMyTasksRoute
  '/notifications': typeof AppNotificationsRoute
  '/project-templates': typeof AppProjectTemplatesRoute
  '/projects': typeof AppProjectsRoute
  '/skills': typeof AppSkillsRoute
  '/forgot-password': typeof PublicForgotPasswordRoute
  '/login': typeof PublicLoginRoute
  '/reset-password': typeof PublicResetPasswordRoute
  '/setup-2fa': typeof PublicSetup2faRoute
  '/admin/audit': typeof AppAdminAuditRoute
  '/admin/job-roles': typeof AppAdminJobRolesRoute
  '/admin/organizations': typeof AppAdminOrganizationsRoute
  '/admin/skills': typeof AppAdminSkillsRoute
  '/admin/system': typeof AppAdminSystemRoute
  '/resources/roles': typeof AppResourcesRolesRoute
  '/invite/$token': typeof PublicInviteTokenRoute
  '/admin': typeof AppAdminIndexRoute
  '/resources': typeof AppResourcesIndexRoute
  '/admin/resources/$userId': typeof AppAdminResourcesUserIdRoute
  '/admin/roles/$roleId': typeof AppAdminRolesRoleIdRoute
  '/admin/roles/new': typeof AppAdminRolesNewRoute
  '/admin/users/$userId': typeof AppAdminUsersUserIdRoute
  '/p/$projectKey/$taskKey': typeof AppPProjectKeyTaskKeyRoute
  '/p/$projectKey/board': typeof AppPProjectKeyBoardRoute
  '/p/$projectKey/calendar': typeof AppPProjectKeyCalendarRoute
  '/p/$projectKey/gantt': typeof AppPProjectKeyGanttRoute
  '/p/$projectKey/resources': typeof AppPProjectKeyResourcesRoute
  '/p/$projectKey/tasks': typeof AppPProjectKeyTasksRoute
  '/resources/people/$userId': typeof AppResourcesPeopleUserIdRoute
  '/admin/resources': typeof AppAdminResourcesIndexRoute
  '/admin/roles': typeof AppAdminRolesIndexRoute
  '/admin/users': typeof AppAdminUsersIndexRoute
  '/p/$projectKey': typeof AppPProjectKeyIndexRoute
  '/p/$projectKey/reports/$reportId': typeof AppPProjectKeyReportsReportIdRoute
  '/p/$projectKey/settings/general': typeof AppPProjectKeySettingsGeneralRoute
  '/p/$projectKey/settings/labels': typeof AppPProjectKeySettingsLabelsRoute
  '/p/$projectKey/settings/members': typeof AppPProjectKeySettingsMembersRoute
  '/p/$projectKey/settings/trash': typeof AppPProjectKeySettingsTrashRoute
  '/p/$projectKey/settings/workflow': typeof AppPProjectKeySettingsWorkflowRoute
  '/p/$projectKey/reports': typeof AppPProjectKeyReportsIndexRoute
  '/p/$projectKey/settings': typeof AppPProjectKeySettingsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/_public': typeof PublicRouteWithChildren
  '/_app/absences': typeof AppAbsencesRoute
  '/_app/admin': typeof AppAdminRouteWithChildren
  '/_app/my-resources': typeof AppMyResourcesRoute
  '/_app/my-tasks': typeof AppMyTasksRoute
  '/_app/notifications': typeof AppNotificationsRoute
  '/_app/project-templates': typeof AppProjectTemplatesRoute
  '/_app/projects': typeof AppProjectsRoute
  '/_app/resources': typeof AppResourcesRouteWithChildren
  '/_app/skills': typeof AppSkillsRoute
  '/_public/forgot-password': typeof PublicForgotPasswordRoute
  '/_public/login': typeof PublicLoginRoute
  '/_public/reset-password': typeof PublicResetPasswordRoute
  '/_public/setup-2fa': typeof PublicSetup2faRoute
  '/_app/': typeof AppIndexRoute
  '/_app/admin/audit': typeof AppAdminAuditRoute
  '/_app/admin/job-roles': typeof AppAdminJobRolesRoute
  '/_app/admin/organizations': typeof AppAdminOrganizationsRoute
  '/_app/admin/skills': typeof AppAdminSkillsRoute
  '/_app/admin/system': typeof AppAdminSystemRoute
  '/_app/p/$projectKey': typeof AppPProjectKeyRouteWithChildren
  '/_app/resources/roles': typeof AppResourcesRolesRoute
  '/_public/invite/$token': typeof PublicInviteTokenRoute
  '/_app/admin/': typeof AppAdminIndexRoute
  '/_app/resources/': typeof AppResourcesIndexRoute
  '/_app/admin/resources/$userId': typeof AppAdminResourcesUserIdRoute
  '/_app/admin/roles/$roleId': typeof AppAdminRolesRoleIdRoute
  '/_app/admin/roles/new': typeof AppAdminRolesNewRoute
  '/_app/admin/users/$userId': typeof AppAdminUsersUserIdRoute
  '/_app/p/$projectKey/$taskKey': typeof AppPProjectKeyTaskKeyRoute
  '/_app/p/$projectKey/board': typeof AppPProjectKeyBoardRoute
  '/_app/p/$projectKey/calendar': typeof AppPProjectKeyCalendarRoute
  '/_app/p/$projectKey/gantt': typeof AppPProjectKeyGanttRoute
  '/_app/p/$projectKey/resources': typeof AppPProjectKeyResourcesRoute
  '/_app/p/$projectKey/settings': typeof AppPProjectKeySettingsRouteWithChildren
  '/_app/p/$projectKey/tasks': typeof AppPProjectKeyTasksRoute
  '/_app/resources/people/$userId': typeof AppResourcesPeopleUserIdRoute
  '/_app/admin/resources/': typeof AppAdminResourcesIndexRoute
  '/_app/admin/roles/': typeof AppAdminRolesIndexRoute
  '/_app/admin/users/': typeof AppAdminUsersIndexRoute
  '/_app/p/$projectKey/': typeof AppPProjectKeyIndexRoute
  '/_app/p/$projectKey/reports/$reportId': typeof AppPProjectKeyReportsReportIdRoute
  '/_app/p/$projectKey/settings/general': typeof AppPProjectKeySettingsGeneralRoute
  '/_app/p/$projectKey/settings/labels': typeof AppPProjectKeySettingsLabelsRoute
  '/_app/p/$projectKey/settings/members': typeof AppPProjectKeySettingsMembersRoute
  '/_app/p/$projectKey/settings/trash': typeof AppPProjectKeySettingsTrashRoute
  '/_app/p/$projectKey/settings/workflow': typeof AppPProjectKeySettingsWorkflowRoute
  '/_app/p/$projectKey/reports/': typeof AppPProjectKeyReportsIndexRoute
  '/_app/p/$projectKey/settings/': typeof AppPProjectKeySettingsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/absences'
    | '/admin'
    | '/my-resources'
    | '/my-tasks'
    | '/notifications'
    | '/project-templates'
    | '/projects'
    | '/resources'
    | '/skills'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/setup-2fa'
    | '/admin/audit'
    | '/admin/job-roles'
    | '/admin/organizations'
    | '/admin/skills'
    | '/admin/system'
    | '/p/$projectKey'
    | '/resources/roles'
    | '/invite/$token'
    | '/admin/'
    | '/resources/'
    | '/admin/resources/$userId'
    | '/admin/roles/$roleId'
    | '/admin/roles/new'
    | '/admin/users/$userId'
    | '/p/$projectKey/$taskKey'
    | '/p/$projectKey/board'
    | '/p/$projectKey/calendar'
    | '/p/$projectKey/gantt'
    | '/p/$projectKey/resources'
    | '/p/$projectKey/settings'
    | '/p/$projectKey/tasks'
    | '/resources/people/$userId'
    | '/admin/resources/'
    | '/admin/roles/'
    | '/admin/users/'
    | '/p/$projectKey/'
    | '/p/$projectKey/reports/$reportId'
    | '/p/$projectKey/settings/general'
    | '/p/$projectKey/settings/labels'
    | '/p/$projectKey/settings/members'
    | '/p/$projectKey/settings/trash'
    | '/p/$projectKey/settings/workflow'
    | '/p/$projectKey/reports/'
    | '/p/$projectKey/settings/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/absences'
    | '/my-resources'
    | '/my-tasks'
    | '/notifications'
    | '/project-templates'
    | '/projects'
    | '/skills'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/setup-2fa'
    | '/admin/audit'
    | '/admin/job-roles'
    | '/admin/organizations'
    | '/admin/skills'
    | '/admin/system'
    | '/resources/roles'
    | '/invite/$token'
    | '/admin'
    | '/resources'
    | '/admin/resources/$userId'
    | '/admin/roles/$roleId'
    | '/admin/roles/new'
    | '/admin/users/$userId'
    | '/p/$projectKey/$taskKey'
    | '/p/$projectKey/board'
    | '/p/$projectKey/calendar'
    | '/p/$projectKey/gantt'
    | '/p/$projectKey/resources'
    | '/p/$projectKey/tasks'
    | '/resources/people/$userId'
    | '/admin/resources'
    | '/admin/roles'
    | '/admin/users'
    | '/p/$projectKey'
    | '/p/$projectKey/reports/$reportId'
    | '/p/$projectKey/settings/general'
    | '/p/$projectKey/settings/labels'
    | '/p/$projectKey/settings/members'
    | '/p/$projectKey/settings/trash'
    | '/p/$projectKey/settings/workflow'
    | '/p/$projectKey/reports'
    | '/p/$projectKey/settings'
  id:
    | '__root__'
    | '/_app'
    | '/_public'
    | '/_app/absences'
    | '/_app/admin'
    | '/_app/my-resources'
    | '/_app/my-tasks'
    | '/_app/notifications'
    | '/_app/project-templates'
    | '/_app/projects'
    | '/_app/resources'
    | '/_app/skills'
    | '/_public/forgot-password'
    | '/_public/login'
    | '/_public/reset-password'
    | '/_public/setup-2fa'
    | '/_app/'
    | '/_app/admin/audit'
    | '/_app/admin/job-roles'
    | '/_app/admin/organizations'
    | '/_app/admin/skills'
    | '/_app/admin/system'
    | '/_app/p/$projectKey'
    | '/_app/resources/roles'
    | '/_public/invite/$token'
    | '/_app/admin/'
    | '/_app/resources/'
    | '/_app/admin/resources/$userId'
    | '/_app/admin/roles/$roleId'
    | '/_app/admin/roles/new'
    | '/_app/admin/users/$userId'
    | '/_app/p/$projectKey/$taskKey'
    | '/_app/p/$projectKey/board'
    | '/_app/p/$projectKey/calendar'
    | '/_app/p/$projectKey/gantt'
    | '/_app/p/$projectKey/resources'
    | '/_app/p/$projectKey/settings'
    | '/_app/p/$projectKey/tasks'
    | '/_app/resources/people/$userId'
    | '/_app/admin/resources/'
    | '/_app/admin/roles/'
    | '/_app/admin/users/'
    | '/_app/p/$projectKey/'
    | '/_app/p/$projectKey/reports/$reportId'
    | '/_app/p/$projectKey/settings/general'
    | '/_app/p/$projectKey/settings/labels'
    | '/_app/p/$projectKey/settings/members'
    | '/_app/p/$projectKey/settings/trash'
    | '/_app/p/$projectKey/settings/workflow'
    | '/_app/p/$projectKey/reports/'
    | '/_app/p/$projectKey/settings/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  PublicRoute: typeof PublicRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/absences': {
      id: '/_app/absences'
      path: '/absences'
      fullPath: '/absences'
      preLoaderRoute: typeof AppAbsencesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin': {
      id: '/_app/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AppAdminRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/my-resources': {
      id: '/_app/my-resources'
      path: '/my-resources'
      fullPath: '/my-resources'
      preLoaderRoute: typeof AppMyResourcesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/my-tasks': {
      id: '/_app/my-tasks'
      path: '/my-tasks'
      fullPath: '/my-tasks'
      preLoaderRoute: typeof AppMyTasksRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/notifications': {
      id: '/_app/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof AppNotificationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/project-templates': {
      id: '/_app/project-templates'
      path: '/project-templates'
      fullPath: '/project-templates'
      preLoaderRoute: typeof AppProjectTemplatesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects': {
      id: '/_app/projects'
      path: '/projects'
      fullPath: '/projects'
      preLoaderRoute: typeof AppProjectsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/resources': {
      id: '/_app/resources'
      path: '/resources'
      fullPath: '/resources'
      preLoaderRoute: typeof AppResourcesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/skills': {
      id: '/_app/skills'
      path: '/skills'
      fullPath: '/skills'
      preLoaderRoute: typeof AppSkillsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_public/forgot-password': {
      id: '/_public/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof PublicForgotPasswordRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/login': {
      id: '/_public/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof PublicLoginRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/reset-password': {
      id: '/_public/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof PublicResetPasswordRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/setup-2fa': {
      id: '/_public/setup-2fa'
      path: '/setup-2fa'
      fullPath: '/setup-2fa'
      preLoaderRoute: typeof PublicSetup2faRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_app/admin/': {
      id: '/_app/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AppAdminIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/audit': {
      id: '/_app/admin/audit'
      path: '/audit'
      fullPath: '/admin/audit'
      preLoaderRoute: typeof AppAdminAuditRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/job-roles': {
      id: '/_app/admin/job-roles'
      path: '/job-roles'
      fullPath: '/admin/job-roles'
      preLoaderRoute: typeof AppAdminJobRolesRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/organizations': {
      id: '/_app/admin/organizations'
      path: '/organizations'
      fullPath: '/admin/organizations'
      preLoaderRoute: typeof AppAdminOrganizationsRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/skills': {
      id: '/_app/admin/skills'
      path: '/skills'
      fullPath: '/admin/skills'
      preLoaderRoute: typeof AppAdminSkillsRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/system': {
      id: '/_app/admin/system'
      path: '/system'
      fullPath: '/admin/system'
      preLoaderRoute: typeof AppAdminSystemRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/p/$projectKey': {
      id: '/_app/p/$projectKey'
      path: '/p/$projectKey'
      fullPath: '/p/$projectKey'
      preLoaderRoute: typeof AppPProjectKeyRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/resources/': {
      id: '/_app/resources/'
      path: '/'
      fullPath: '/resources/'
      preLoaderRoute: typeof AppResourcesIndexRouteImport
      parentRoute: typeof AppResourcesRoute
    }
    '/_app/resources/roles': {
      id: '/_app/resources/roles'
      path: '/roles'
      fullPath: '/resources/roles'
      preLoaderRoute: typeof AppResourcesRolesRouteImport
      parentRoute: typeof AppResourcesRoute
    }
    '/_public/invite/$token': {
      id: '/_public/invite/$token'
      path: '/invite/$token'
      fullPath: '/invite/$token'
      preLoaderRoute: typeof PublicInviteTokenRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_app/admin/resources/': {
      id: '/_app/admin/resources/'
      path: '/resources'
      fullPath: '/admin/resources/'
      preLoaderRoute: typeof AppAdminResourcesIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/resources/$userId': {
      id: '/_app/admin/resources/$userId'
      path: '/resources/$userId'
      fullPath: '/admin/resources/$userId'
      preLoaderRoute: typeof AppAdminResourcesUserIdRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/roles/': {
      id: '/_app/admin/roles/'
      path: '/roles'
      fullPath: '/admin/roles/'
      preLoaderRoute: typeof AppAdminRolesIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/roles/$roleId': {
      id: '/_app/admin/roles/$roleId'
      path: '/roles/$roleId'
      fullPath: '/admin/roles/$roleId'
      preLoaderRoute: typeof AppAdminRolesRoleIdRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/roles/new': {
      id: '/_app/admin/roles/new'
      path: '/roles/new'
      fullPath: '/admin/roles/new'
      preLoaderRoute: typeof AppAdminRolesNewRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/users/': {
      id: '/_app/admin/users/'
      path: '/users'
      fullPath: '/admin/users/'
      preLoaderRoute: typeof AppAdminUsersIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/users/$userId': {
      id: '/_app/admin/users/$userId'
      path: '/users/$userId'
      fullPath: '/admin/users/$userId'
      preLoaderRoute: typeof AppAdminUsersUserIdRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/p/$projectKey/': {
      id: '/_app/p/$projectKey/'
      path: '/'
      fullPath: '/p/$projectKey/'
      preLoaderRoute: typeof AppPProjectKeyIndexRouteImport
      parentRoute: typeof AppPProjectKeyRoute
    }
    '/_app/p/$projectKey/$taskKey': {
      id: '/_app/p/$projectKey/$taskKey'
      path: '/$taskKey'
      fullPath: '/p/$projectKey/$taskKey'
      preLoaderRoute: typeof AppPProjectKeyTaskKeyRouteImport
      parentRoute: typeof AppPProjectKeyRoute
    }
    '/_app/p/$projectKey/board': {
      id: '/_app/p/$projectKey/board'
      path: '/board'
      fullPath: '/p/$projectKey/board'
      preLoaderRoute: typeof AppPProjectKeyBoardRouteImport
      parentRoute: typeof AppPProjectKeyRoute
    }
    '/_app/p/$projectKey/calendar': {
      id: '/_app/p/$projectKey/calendar'
      path: '/calendar'
      fullPath: '/p/$projectKey/calendar'
      preLoaderRoute: typeof AppPProjectKeyCalendarRouteImport
      parentRoute: typeof AppPProjectKeyRoute
    }
    '/_app/p/$projectKey/gantt': {
      id: '/_app/p/$projectKey/gantt'
      path: '/gantt'
      fullPath: '/p/$projectKey/gantt'
      preLoaderRoute: typeof AppPProjectKeyGanttRouteImport
      parentRoute: typeof AppPProjectKeyRoute
    }
    '/_app/p/$projectKey/resources': {
      id: '/_app/p/$projectKey/resources'
      path: '/resources'
      fullPath: '/p/$projectKey/resources'
      preLoaderRoute: typeof AppPProjectKeyResourcesRouteImport
      parentRoute: typeof AppPProjectKeyRoute
    }
    '/_app/p/$projectKey/settings': {
      id: '/_app/p/$projectKey/settings'
      path: '/settings'
      fullPath: '/p/$projectKey/settings'
      preLoaderRoute: typeof AppPProjectKeySettingsRouteImport
      parentRoute: typeof AppPProjectKeyRoute
    }
    '/_app/p/$projectKey/tasks': {
      id: '/_app/p/$projectKey/tasks'
      path: '/tasks'
      fullPath: '/p/$projectKey/tasks'
      preLoaderRoute: typeof AppPProjectKeyTasksRouteImport
      parentRoute: typeof AppPProjectKeyRoute
    }
    '/_app/resources/people/$userId': {
      id: '/_app/resources/people/$userId'
      path: '/people/$userId'
      fullPath: '/resources/people/$userId'
      preLoaderRoute: typeof AppResourcesPeopleUserIdRouteImport
      parentRoute: typeof AppResourcesRoute
    }
    '/_app/p/$projectKey/reports/': {
      id: '/_app/p/$projectKey/reports/'
      path: '/reports'
      fullPath: '/p/$projectKey/reports/'
      preLoaderRoute: typeof AppPProjectKeyReportsIndexRouteImport
      parentRoute: typeof AppPProjectKeyRoute
    }
    '/_app/p/$projectKey/reports/$reportId': {
      id: '/_app/p/$projectKey/reports/$reportId'
      path: '/reports/$reportId'
      fullPath: '/p/$projectKey/reports/$reportId'
      preLoaderRoute: typeof AppPProjectKeyReportsReportIdRouteImport
      parentRoute: typeof AppPProjectKeyRoute
    }
    '/_app/p/$projectKey/settings/': {
      id: '/_app/p/$projectKey/settings/'
      path: '/'
      fullPath: '/p/$projectKey/settings/'
      preLoaderRoute: typeof AppPProjectKeySettingsIndexRouteImport
      parentRoute: typeof AppPProjectKeySettingsRoute
    }
    '/_app/p/$projectKey/settings/general': {
      id: '/_app/p/$projectKey/settings/general'
      path: '/general'
      fullPath: '/p/$projectKey/settings/general'
      preLoaderRoute: typeof AppPProjectKeySettingsGeneralRouteImport
      parentRoute: typeof AppPProjectKeySettingsRoute
    }
    '/_app/p/$projectKey/settings/labels': {
      id: '/_app/p/$projectKey/settings/labels'
      path: '/labels'
      fullPath: '/p/$projectKey/settings/labels'
      preLoaderRoute: typeof AppPProjectKeySettingsLabelsRouteImport
      parentRoute: typeof AppPProjectKeySettingsRoute
    }
    '/_app/p/$projectKey/settings/members': {
      id: '/_app/p/$projectKey/settings/members'
      path: '/members'
      fullPath: '/p/$projectKey/settings/members'
      preLoaderRoute: typeof AppPProjectKeySettingsMembersRouteImport
      parentRoute: typeof AppPProjectKeySettingsRoute
    }
    '/_app/p/$projectKey/settings/trash': {
      id: '/_app/p/$projectKey/settings/trash'
      path: '/trash'
      fullPath: '/p/$projectKey/settings/trash'
      preLoaderRoute: typeof AppPProjectKeySettingsTrashRouteImport
      parentRoute: typeof AppPProjectKeySettingsRoute
    }
    '/_app/p/$projectKey/settings/workflow': {
      id: '/_app/p/$projectKey/settings/workflow'
      path: '/workflow'
      fullPath: '/p/$projectKey/settings/workflow'
      preLoaderRoute: typeof AppPProjectKeySettingsWorkflowRouteImport
      parentRoute: typeof AppPProjectKeySettingsRoute
    }
  }
}

interface AppAdminRouteChildren {
  AppAdminAuditRoute: typeof AppAdminAuditRoute
  AppAdminJobRolesRoute: typeof AppAdminJobRolesRoute
  AppAdminOrganizationsRoute: typeof AppAdminOrganizationsRoute
  AppAdminSkillsRoute: typeof AppAdminSkillsRoute
  AppAdminSystemRoute: typeof AppAdminSystemRoute
  AppAdminIndexRoute: typeof AppAdminIndexRoute
  AppAdminResourcesUserIdRoute: typeof AppAdminResourcesUserIdRoute
  AppAdminRolesRoleIdRoute: typeof AppAdminRolesRoleIdRoute
  AppAdminRolesNewRoute: typeof AppAdminRolesNewRoute
  AppAdminUsersUserIdRoute: typeof AppAdminUsersUserIdRoute
  AppAdminResourcesIndexRoute: typeof AppAdminResourcesIndexRoute
  AppAdminRolesIndexRoute: typeof AppAdminRolesIndexRoute
  AppAdminUsersIndexRoute: typeof AppAdminUsersIndexRoute
}

const AppAdminRouteChildren: AppAdminRouteChildren = {
  AppAdminAuditRoute: AppAdminAuditRoute,
  AppAdminJobRolesRoute: AppAdminJobRolesRoute,
  AppAdminOrganizationsRoute: AppAdminOrganizationsRoute,
  AppAdminSkillsRoute: AppAdminSkillsRoute,
  AppAdminSystemRoute: AppAdminSystemRoute,
  AppAdminIndexRoute: AppAdminIndexRoute,
  AppAdminResourcesUserIdRoute: AppAdminResourcesUserIdRoute,
  AppAdminRolesRoleIdRoute: AppAdminRolesRoleIdRoute,
  AppAdminRolesNewRoute: AppAdminRolesNewRoute,
  AppAdminUsersUserIdRoute: AppAdminUsersUserIdRoute,
  AppAdminResourcesIndexRoute: AppAdminResourcesIndexRoute,
  AppAdminRolesIndexRoute: AppAdminRolesIndexRoute,
  AppAdminUsersIndexRoute: AppAdminUsersIndexRoute,
}

const AppAdminRouteWithChildren = AppAdminRoute._addFileChildren(
  AppAdminRouteChildren,
)

interface AppResourcesRouteChildren {
  AppResourcesRolesRoute: typeof AppResourcesRolesRoute
  AppResourcesIndexRoute: typeof AppResourcesIndexRoute
  AppResourcesPeopleUserIdRoute: typeof AppResourcesPeopleUserIdRoute
}

const AppResourcesRouteChildren: AppResourcesRouteChildren = {
  AppResourcesRolesRoute: AppResourcesRolesRoute,
  AppResourcesIndexRoute: AppResourcesIndexRoute,
  AppResourcesPeopleUserIdRoute: AppResourcesPeopleUserIdRoute,
}

const AppResourcesRouteWithChildren = AppResourcesRoute._addFileChildren(
  AppResourcesRouteChildren,
)

interface AppPProjectKeySettingsRouteChildren {
  AppPProjectKeySettingsGeneralRoute: typeof AppPProjectKeySettingsGeneralRoute
  AppPProjectKeySettingsLabelsRoute: typeof AppPProjectKeySettingsLabelsRoute
  AppPProjectKeySettingsMembersRoute: typeof AppPProjectKeySettingsMembersRoute
  AppPProjectKeySettingsTrashRoute: typeof AppPProjectKeySettingsTrashRoute
  AppPProjectKeySettingsWorkflowRoute: typeof AppPProjectKeySettingsWorkflowRoute
  AppPProjectKeySettingsIndexRoute: typeof AppPProjectKeySettingsIndexRoute
}

const AppPProjectKeySettingsRouteChildren: AppPProjectKeySettingsRouteChildren =
  {
    AppPProjectKeySettingsGeneralRoute: AppPProjectKeySettingsGeneralRoute,
    AppPProjectKeySettingsLabelsRoute: AppPProjectKeySettingsLabelsRoute,
    AppPProjectKeySettingsMembersRoute: AppPProjectKeySettingsMembersRoute,
    AppPProjectKeySettingsTrashRoute: AppPProjectKeySettingsTrashRoute,
    AppPProjectKeySettingsWorkflowRoute: AppPProjectKeySettingsWorkflowRoute,
    AppPProjectKeySettingsIndexRoute: AppPProjectKeySettingsIndexRoute,
  }

const AppPProjectKeySettingsRouteWithChildren =
  AppPProjectKeySettingsRoute._addFileChildren(
    AppPProjectKeySettingsRouteChildren,
  )

interface AppPProjectKeyRouteChildren {
  AppPProjectKeyTaskKeyRoute: typeof AppPProjectKeyTaskKeyRoute
  AppPProjectKeyBoardRoute: typeof AppPProjectKeyBoardRoute
  AppPProjectKeyCalendarRoute: typeof AppPProjectKeyCalendarRoute
  AppPProjectKeyGanttRoute: typeof AppPProjectKeyGanttRoute
  AppPProjectKeyResourcesRoute: typeof AppPProjectKeyResourcesRoute
  AppPProjectKeySettingsRoute: typeof AppPProjectKeySettingsRouteWithChildren
  AppPProjectKeyTasksRoute: typeof AppPProjectKeyTasksRoute
  AppPProjectKeyIndexRoute: typeof AppPProjectKeyIndexRoute
  AppPProjectKeyReportsReportIdRoute: typeof AppPProjectKeyReportsReportIdRoute
  AppPProjectKeyReportsIndexRoute: typeof AppPProjectKeyReportsIndexRoute
}

const AppPProjectKeyRouteChildren: AppPProjectKeyRouteChildren = {
  AppPProjectKeyTaskKeyRoute: AppPProjectKeyTaskKeyRoute,
  AppPProjectKeyBoardRoute: AppPProjectKeyBoardRoute,
  AppPProjectKeyCalendarRoute: AppPProjectKeyCalendarRoute,
  AppPProjectKeyGanttRoute: AppPProjectKeyGanttRoute,
  AppPProjectKeyResourcesRoute: AppPProjectKeyResourcesRoute,
  AppPProjectKeySettingsRoute: AppPProjectKeySettingsRouteWithChildren,
  AppPProjectKeyTasksRoute: AppPProjectKeyTasksRoute,
  AppPProjectKeyIndexRoute: AppPProjectKeyIndexRoute,
  AppPProjectKeyReportsReportIdRoute: AppPProjectKeyReportsReportIdRoute,
  AppPProjectKeyReportsIndexRoute: AppPProjectKeyReportsIndexRoute,
}

const AppPProjectKeyRouteWithChildren = AppPProjectKeyRoute._addFileChildren(
  AppPProjectKeyRouteChildren,
)

interface AppRouteChildren {
  AppAbsencesRoute: typeof AppAbsencesRoute
  AppAdminRoute: typeof AppAdminRouteWithChildren
  AppMyResourcesRoute: typeof AppMyResourcesRoute
  AppMyTasksRoute: typeof AppMyTasksRoute
  AppNotificationsRoute: typeof AppNotificationsRoute
  AppProjectTemplatesRoute: typeof AppProjectTemplatesRoute
  AppProjectsRoute: typeof AppProjectsRoute
  AppResourcesRoute: typeof AppResourcesRouteWithChildren
  AppSkillsRoute: typeof AppSkillsRoute
  AppIndexRoute: typeof AppIndexRoute
  AppPProjectKeyRoute: typeof AppPProjectKeyRouteWithChildren
}

const AppRouteChildren: AppRouteChildren = {
  AppAbsencesRoute: AppAbsencesRoute,
  AppAdminRoute: AppAdminRouteWithChildren,
  AppMyResourcesRoute: AppMyResourcesRoute,
  AppMyTasksRoute: AppMyTasksRoute,
  AppNotificationsRoute: AppNotificationsRoute,
  AppProjectTemplatesRoute: AppProjectTemplatesRoute,
  AppProjectsRoute: AppProjectsRoute,
  AppResourcesRoute: AppResourcesRouteWithChildren,
  AppSkillsRoute: AppSkillsRoute,
  AppIndexRoute: AppIndexRoute,
  AppPProjectKeyRoute: AppPProjectKeyRouteWithChildren,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface PublicRouteChildren {
  PublicForgotPasswordRoute: typeof PublicForgotPasswordRoute
  PublicLoginRoute: typeof PublicLoginRoute
  PublicResetPasswordRoute: typeof PublicResetPasswordRoute
  PublicSetup2faRoute: typeof PublicSetup2faRoute
  PublicInviteTokenRoute: typeof PublicInviteTokenRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicForgotPasswordRoute: PublicForgotPasswordRoute,
  PublicLoginRoute: PublicLoginRoute,
  PublicResetPasswordRoute: PublicResetPasswordRoute,
  PublicSetup2faRoute: PublicSetup2faRoute,
  PublicInviteTokenRoute: PublicInviteTokenRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  PublicRoute: PublicRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
